var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUmbrella = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.022 11.5c.324-4.463 4.227-8 8.978-8 4.766 0 8.678 3.54 8.981 8zM12.5 2.524V1.5a.5.5 0 0 0-1 0v1.024C6.205 2.775 2 6.954 2 12.102c0 .221.23.398.461.398H11.5v7.895c0 .9.715 1.605 1.628 1.605s1.627-.705 1.627-1.605v-1.042a.5.5 0 1 0-1 0v1.042c0 .344-.27.605-.627.605-.358 0-.628-.261-.628-.605V12.5h9.039c.276 0 .461-.177.461-.442 0-5.105-4.205-9.283-9.5-9.534",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUmbrella);
export default ForwardRef;